import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import MainPage from '../components/MainPage';
import getOperators from '../actions/api/operators/getOperators';
import getCompanies from '../actions/api/company/getCompanies';
import config from '../config';
import { isServiceVendor } from '../lib/tools';
import { ROLE, REMOTE_SUPPORT_STATUS } from '../lib/constants';

const INTERVAL_TIMER = 10000;

const updateContainer = (apiToken, dispatch, params) => {
  const { role } = params;
  const { searchCompany } = config.customRole.functionAccess;
  if (searchCompany.indexOf(role) !== -1) {
    // SP企業ユーザのみ企業情報取得
    dispatch(getCompanies(apiToken));
  }
};

const callGetOperatorsApi = (apiToken, dispatch, params) => {
  const {
    role,
    selectedCompanyId,
    selectedRoleId,
    namePartial,
    selectedStatus,
    selectedRemoteSupportStatus,
    groupId = null,
  } = params;
  const allRoles = [ROLE.GUEST, ROLE.GENERAL, ROLE.ADMIN, ROLE.COMPANY_ADMIN];
  const roles = selectedRoleId === ROLE.ALL ? allRoles : [selectedRoleId];

  const searchUserName = (namePartial && { namePartial }) || {};
  const accountStatuses =
    (selectedStatus !== config.accountStatus.ALL && [selectedStatus]) ||
    config.searchAccountStatus.notDeleted;
  const remoteSupportStatuses =
    (selectedRemoteSupportStatus !== REMOTE_SUPPORT_STATUS.all && [
      selectedRemoteSupportStatus,
    ]) ||
    [];
  // APIパラメータ
  let options = {
    roles,
    ...searchUserName,
    accountStatuses,
    remoteSupportStatuses,
  };
  if (isServiceVendor(role)) {
    // SPユーザの場合は企業管理一覧の検索オプションエリアで選択した企業IDを設定する
    const companyIds = (selectedCompanyId > 0 && [selectedCompanyId]) || null;
    options = { ...options, companyIds };
  } else {
    // その他ユーザ（企業管理者、現場管理者想定）はツールバーで選択したグループIDを設定する
    options = { ...options, groupIds: groupId ? [groupId] : null };
  }
  dispatch(getOperators(apiToken, { ...options }));
};

const scrollTop = () => {
  // ページネーションなどでページ更新した時にスクロールバーをトップに戻す
  const obj = document.getElementById('canStaffScrollTable');
  if (obj) {
    obj.scrollTop = 0;
  }
};
const getSearchBoxHeight = () => {
  const obj = document.getElementById('StaffPageSearchBox');
  return (obj && obj.clientHeight) || 0;
};
class StaffContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchBoxHeight: 0,
    };
    const { apiToken, role, dispatch, showUserPrompt } = props;
    dispatch({ type: 'CLOSE_MENU' });
    dispatch({ type: 'RESET_OPERATOR_INFO' });
    dispatch({ type: 'OPEN_STAFF' });
    dispatch({ type: 'SEARCH_USER_NAME', namePartial: '' });
    dispatch({ type: 'SELECT_COMPANY', companyId: null });
    dispatch({ type: 'SELECT_ROLE', roleId: ROLE.ALL });
    dispatch({
      type: 'SELECT_ACCOUNT_STATUS',
      status: config.accountStatus.ALL,
    });
    dispatch({
      type: 'SELECT_REMOTE_SUPPORT_STATUS',
      status: REMOTE_SUPPORT_STATUS.all,
    });
    const canUpdate = !props.showUserPrompt || props.isLogin;
    if (canUpdate) {
      updateContainer(apiToken, dispatch, { role });
      this.initialTimer({ dispatch, apiToken, showUserPrompt, role });
    }
  }

  componentDidMount() {
    const searchBoxHeight = getSearchBoxHeight();
    this.setState({ searchBoxHeight });
  }

  shouldComponentUpdate(props, state) {
    scrollTop();
    const resizedSearchBoxHeight = getSearchBoxHeight();
    const curSearchBoxHeight = state.searchBoxHeight;
    if (resizedSearchBoxHeight !== curSearchBoxHeight) {
      this.setState({ searchBoxHeight: resizedSearchBoxHeight });
    }
    const {
      apiToken,
      role,
      dispatch,
      showUserPrompt,
      selectedCompanyId,
      selectedRoleId,
      namePartial,
      selectedStatus,
      selectedRemoteSupportStatus,
    } = props;
    const operatorSearchOptions = {
      role,
      selectedCompanyId,
      selectedRoleId,
      namePartial,
      selectedStatus,
      selectedRemoteSupportStatus,
    };
    callGetOperatorsApi(apiToken, dispatch, operatorSearchOptions);

    this.initialTimer({ apiToken, role, dispatch, showUserPrompt });
    return true;
  }

  componentWillUnmount() {
    this.closeTimer();
  }

  initialTimer(params) {
    const { dispatch, apiToken, showUserPrompt, role } = params;
    this.closeTimer();
    if (dispatch && apiToken && !showUserPrompt) {
      const apiParams = { role };
      updateContainer(apiToken, dispatch, apiParams);
      this.mainTimer = setInterval(
        () => updateContainer(apiToken, dispatch, apiParams),
        INTERVAL_TIMER,
      );
    }
  }

  closeTimer() {
    if (this.mainTimer !== undefined) {
      clearInterval(this.mainTimer);
      delete this.mainTimer;
    }
  }

  render() {
    const { isLogin } = this.props;
    const { searchBoxHeight } = this.state;
    return (
      (!isLogin && <Redirect to="/login" />) || (
        <MainPage searchBoxHeight={searchBoxHeight} />
      )
    );
  }
}

StaffContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  isLogin: PropTypes.bool.isRequired,
  apiToken: PropTypes.string.isRequired,
  role: PropTypes.number.isRequired,
  selectedCompanyId: PropTypes.number.isRequired,
  selectedRoleId: PropTypes.number.isRequired,
  namePartial: PropTypes.string.isRequired,
  selectedStatus: PropTypes.number.isRequired,
  selectedRemoteSupportStatus: PropTypes.number.isRequired,
  showUserPrompt: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  isLogin: state.main.isLogin,
  compatibleInfo: state.main.compatibleInfo,
  apiToken: state.main.apiToken,
  role: state.main.userInfo.role,
  selectedCompanyId: state.company.selectedCompanyId,
  selectedRoleId: state.company.selectedRoleId,
  namePartial: state.company.namePartial,
  selectedStatus: state.company.selectedStatus,
  selectedRemoteSupportStatus: state.company.selectedRemoteSupportStatus,
  showUserPrompt: state.userPrompt.showUserPrompt,
  refreshPage: state.operator.refreshPage,
});

export default connect(mapStateToProps)(StaffContainer);
